"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recent_Foods = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var api_1 = require("../api");
function Recent_Foods(props) {
    var _this = this;
    var _a = (0, react_1.useState)([]), recent_foods = _a[0], set_recent_foods = _a[1];
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, api_1.get_recent_foods)()];
                    case 1:
                        data = _a.sent();
                        // const json = await response.json();
                        set_recent_foods(data);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData()
            .catch(console.error);
        // const data = get_recent_foods();
        // set_recent_foods(data);
    }, []);
    function add_recent_food(food) {
        return __awaiter(this, void 0, void 0, function () {
            var food_copy, food_nutrients;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        food_copy = food;
                        return [4 /*yield*/, (0, api_1.search_nutritionix_food_nutrients)(food.food_name)];
                    case 1:
                        food_nutrients = _a.sent();
                        food_copy.alt_measures = food_nutrients.alt_measures;
                        props.set_food(food_copy);
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement(Wrapper, null, recent_foods &&
        recent_foods.map(function (food) {
            return (react_1.default.createElement(Food_Item, { key: food.transaction_id, onClick: function () { add_recent_food(food); } },
                react_1.default.createElement(Food_Name, null, food.food_name),
                react_1.default.createElement(Food_Cals, null, food.calories_per_serving)));
        })));
}
exports.Recent_Foods = Recent_Foods;
var Wrapper = styled_components_1.default.div.withConfig({ displayName: "Recent_Foods.tsx-Wrapper", componentId: "-1g4aoc9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    /* background: blue; */\n"], ["\n    /* background: blue; */\n"])));
var Food_Item = styled_components_1.default.div.withConfig({ displayName: "Recent_Foods.tsx-Food_Item", componentId: "-pevl65" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    background: ", ";\n    margin-bottom: 3px;\n\n    :hover {\n        background: ", ";\n    }\n"], ["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    background: ", ";\n    margin-bottom: 3px;\n\n    :hover {\n        background: ", ";\n    }\n"])), function (props) { return props.theme.dp2; }, function (props) { return props.theme.dp4; });
var Food_Name = styled_components_1.default.div.withConfig({ displayName: "Recent_Foods.tsx-Food_Name", componentId: "-167sbl6" })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Food_Cals = styled_components_1.default.div.withConfig({ displayName: "Recent_Foods.tsx-Food_Cals", componentId: "-18nafja" })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=data:application/json;base64,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